import { useQuery, useQueryClient } from '@tanstack/react-query';
import {
  workspace_v1_WorkspaceConfig,
  workspaceV1GetConfigOptions,
  workspaceV1GetConfigQueryKey,
} from '@antimatterhq/asl-api-ts-v1';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useGetWorkspaceConfig = (
  {
    refetchInterval = false,
  }: {
    refetchInterval: number | false;
  } = { refetchInterval: false },
) => {
  const { workspace } = useWorkspace();
  return useQuery({
    ...workspaceV1GetConfigOptions({
      ...defaultOptions(),
      path: { workspace },
    }),
    enabled: !!workspace,
    refetchInterval,
  });
};

export const useOptimisticUpdateWorkspaceConfig = () => {
  const { workspace } = useWorkspace();
  const queryClient = useQueryClient();

  return (config: workspace_v1_WorkspaceConfig) => {
    queryClient.setQueryData(
      workspaceV1GetConfigQueryKey({
        ...defaultOptions(),
        path: { workspace },
      }),
      config,
    );
  };
};
